import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-internal-complaint-committee',
  templateUrl: './internal-complaint-committee.component.html',
  styleUrls: ['./internal-complaint-committee.component.scss']
})
export class InternalComplaintCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
